import {
    ActionPlanOverview,
    CompanyOverview,
    ScoreOverview,
} from "src/api/client-api/company/overview/useOrganizationOverview";
import { QuestionnaireOverview } from "src/api/client-api/company/overview/useOrganizationOverviewOneSsq";

type Options = {
    overview: CompanyOverview;
};
/*  Links together a bundle of SSQ - Score and ActionPlan
 */
export const getActionPlanOverviewList = (options: Options): ActionPlanOverviewList[] => {
    const {
        overview: { actionPlans, scores, ssqs },
    } = options;

    const actionPlanList = ssqs.flatMap((ssq, index) => {
        const linkedScore = scores.find((score) => {
            // First, I want the right scores;
            if (score.ssq.id !== ssq.id) {
                return false;
            }

            // Then, if it's valid;
            return score.isActionPlanAvailable;
        });
        if (linkedScore === undefined) {
            return [];
        }

        const existingActionPlan = actionPlans.find((actPlan) => {
            return actPlan.ssqId === ssq.id;
        });

        const isActionable = linkedScore.isActionPlanAvailable;
        if (isActionable === false) {
            return [];
        }

        return {
            ssq,
            linkedScore,
            isActionable: isActionable,
            existingActionPlan,
        };
    });

    return actionPlanList;
};

export type ActionPlanOverviewList = {
    ssq: QuestionnaireOverview;
    linkedScore: ScoreOverview | undefined;
    existingActionPlan: ActionPlanOverview | undefined;
    isActionable: boolean;
};
